import { render } from "./SubmitUsernameView.vue?vue&type=template&id=07acd1a4&scoped=true"
import script from "./SubmitUsernameView.vue?vue&type=script&lang=js"
export * from "./SubmitUsernameView.vue?vue&type=script&lang=js"

import "./SubmitUsernameView.vue?vue&type=style&index=0&id=07acd1a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07acd1a4"]])

export default __exports__